/**
 * Created by Ning Jiang on 2/13/2019.
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {IntroFeatureLogo} from "@nolimitcity/slot-game/bin/core/gameintro/GameIntroView";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {UserAgent} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {IndividualWinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {SymbolIdleAnimationController} from "@nolimitcity/slot-game/bin/game/idleanimation/symbolidleanimation/SymbolIdleAnimationController";
import {FringeSymbolsController} from "@nolimitcity/slot-game/bin/game/reelstoppresentation/FringeSymbolsController";
import {RespinZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/RespinZeroBetController";
import {LogoOnBackground} from "./background/LogoOnBackground";
import {WixxBackground} from "./background/WixxBackground";
import {WixxForegroundRespinController} from "./foreground/WixxForegroundRespinController";
import {WixxIntroScreenView} from "./intro/WixxIntroScreenView";
import {BackgroundParticles} from "./particles/BackgroundParticles";
import {WixxFirstNearWinReelController} from "./reel/WixxFirstNearWinReelController";
import {WixxReelController} from "./reel/WixxReelController";
import {WixxStackedReelController} from "./reel/WixxStackedReelController";
import {WixxStackedReelView} from "./reel/WixxStackedReelView";
import {WixxNearWinReelDivider} from "./reeldivider/WixxNearWinReelDivider";
import {WixxWildLandingAttentionController} from "./reelstoppresentation/wildlandingattention/WixxWildLandingAttentionController";
import {WixxReelStopPresentationController} from "./reelstoppresentation/WixxReelStopPresentationController";
import {WixxReelSymbol} from "./reelsymbol/WixxReelSymbol";
import {WixxParsedGameData} from "./server/data/WixxParsedGameData";
import {WixxParsedInitData} from "./server/data/WixxParsedInitData";
import {WixxServerDataParser} from "./server/WixxServerDataParser";
import {WixxSpinController} from "./spin/WixxSpinController";
import {WixxBigWinController} from "./winpresentation/bigwin/WixxBigWinController";
import {BoosterWinPresentationController} from "./winpresentation/booster/BoosterWinPresentationController";
import {WixxWinCountUp} from "./winpresentation/countup/WixxWinCountUp";
import {WixxIndividualWPController} from "./winpresentation/individual/WixxIndividualWPController";
import {WixxInitialWPController} from "./winpresentation/initial/WixxInitialWPController";
import {WinWaysWonIndicator} from "./winpresentation/winwayswon/WinWaysWonIndicator";
import {Wixx} from "./Wixx";
import {WixxFontConfig} from "./WixxFontConfig";
import {WixxGameAssets} from "./WixxGameAssets";
import {WixxGameConfig} from "./WixxGameConfig";
import {WixxSoundConfig} from "./WixxSoundConfig";
import {IndiSymWinHighlightPresentation} from "./winpresentation/IndiSymWinHighlightPresentation";

export class WixxGameModuleConfig implements IGameModuleConfig {

    public static instance:WixxGameModuleConfig = new WixxGameModuleConfig();

    GAME_CONFIG:IGameConfig = WixxGameConfig.instance;
    SOUND_CONFIG:ISoundConfig = WixxSoundConfig.instance;
    FONTS_CONFIG:IFontsConfig = WixxFontConfig.FONTS;
    RESOURCES_CONFIG:IResourcesGroupConfig = WixxGameAssets.RESOURCES_GROUPS;

    SERVER_PARSER:() => ServerDataParser = () => new WixxServerDataParser();
    PARSED_INIT_DATA:(data:any, dataParser:ServerDataParser) => ParsedInitData = (data:any, dataParser:ServerDataParser) => new WixxParsedInitData(data, <WixxServerDataParser>dataParser);
    PARSED_GAME_DATA:(data:any, dataParser:ServerDataParser) => ParsedGameData = (data:any, dataParser:ServerDataParser) => new WixxParsedGameData(data, <WixxServerDataParser>dataParser);

    SPIN_CONTROLLER:() => SpinController = () => new WixxSpinController();

    REEL_CONTROLLER:(reelId:number) => ReelController = (reelId:number) => {
        if(reelId === 0) {
            return new WixxFirstNearWinReelController(reelId);
        }
        if(reelId === 3) {
            return new WixxStackedReelController(reelId);
        }

        return new WixxReelController(reelId);
    };

    REEL_VIEW:(reelId:number) => PIXI.Container = (reelId:number) => {
        if(reelId === 3) {
            return new WixxStackedReelView();
        }
        return new PIXI.Sprite();
    };

    REEL_PART_CREATOR:() => ReelPartCreator = () => new ReelPartCreator(
        (symName:string, reelId:number, state?:ISymbolStateConfig):WixxReelSymbol => {
            return new WixxReelSymbol(symName, reelId, state);
        });

    ZERO_BETS:(() => ZeroBetController)[] = [
        () => new RespinZeroBetController()
    ];

    REEL_STOP_PRESENTATIONS:((index:number) => ReelStopPresentationController)[] = [
        (index:number) => new FringeSymbolsController(index, {
            duration : 0.5,
            state : WixxGameConfig.instance.SYMBOL_STATES.noWin!
        }),
        (index:number) => new WixxReelStopPresentationController(index),
        (index:number) => new WixxWildLandingAttentionController(index)
    ];

    WIN_PRESENTATIONS:((indexes:[number, number]) => WinPresentationController)[][] = [
        [indexes => new IndiSymWinHighlightPresentation(indexes)],
            [
            indexes => new WixxBigWinController(indexes),
            indexes => new WixxInitialWPController(indexes)
        ],
        [indexes => new BoosterWinPresentationController(indexes)]
    ];

    INDIVIDUAL_WIN_PRESENTATION:() => IndividualWinPresentationController = () => {
        return new WixxIndividualWPController({
            symbolTimeOffsetCalculator : (currentTotalDuration:number, reelId:number, symbolId:number):number => {
                return currentTotalDuration === 0 ? 0 : currentTotalDuration - (1.2 + (reelId * reelId) / 22);
            }
        });
    };

    GAME_FEATURE_CREATOR:() => void = () => {
        const background = new WixxBackground({
            layer : GameConfig.instance.LAYERS.BACKGROUND.name,
            backgroundImages : {
                NORMAL : {image : "mainBackground"}
            },
            stretch : true
        });
        const reelDivider = new WixxNearWinReelDivider({
            layer : GameConfig.instance.LAYERS.REEL_ATTENTION.name,
            texturesGetter : (index:number) => {return null;},
            positions : [[202, 0], [422, 0], [642, 0], [862, 0], [1082, 0]],
            nearWinLayer : GameConfig.instance.LAYERS.REEL_ATTENTION.name,
            nearWinTexturesGetter : (index:number) => {
                return GameResources.getTextures("nearWinReelDivider");
            },
            reelIndexMap : [[0, 1], [1, 2], [2, 3], [3, 4]],
            nearWinSounds : [
                WixxSoundConfig.instance.REEL_NEAR_WIN_1,
                WixxSoundConfig.instance.REEL_NEAR_WIN_2,
                WixxSoundConfig.instance.REEL_NEAR_WIN_3,
                WixxSoundConfig.instance.REEL_NEAR_WIN_4],
            nearWinBlendMode : PIXI.BLEND_MODES.ADD
        });
        const winWaysWon = new WinWaysWonIndicator();
        const respinText = new WixxForegroundRespinController();
        const logoOnBackground = new LogoOnBackground();
        Wixx.particles = new BackgroundParticles();
        Wixx.winCountUp = new WixxWinCountUp();

        if(!UserAgent.isMobile) {
            const idleAnimation = new SymbolIdleAnimationController({
                startTime : 3,
                minInterval : 0.1,
                maxInterval : 3
            });
        }

        StageManager.legacyScaling = true;
    };

    constructor() {
        if(WixxGameModuleConfig.instance) {
            throw new Error("WixxGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}